import { receiptNoDisplay } from "./feeHelpers";

export default function FeeReceiptNo({ value, size = "md", showLabel = false }) {
  const display = receiptNoDisplay(value);

  if (!value || display === "—") {
    return <span className="fee-receipt-empty">—</span>;
  }

  return (
    <span
      className={`fee-receipt-voucher is-${size}${showLabel ? " has-label" : ""}`}
      title={display}
    >
      {showLabel ? <span className="fee-receipt-label">Receipt No.</span> : null}
      <span className="fee-receipt-value">{display}</span>
    </span>
  );
}
